import { isArray, mergeWith } from 'lodash-es';

import {
  SHIPMENT_FORM_AUTOFILL_QUERY,
  SHIPMENT_FORM_GET_OPTIONS_QUERY,
  SHIPMENT_FORM_SCHEMA_QUERY,
  VALIDATE_SHIPMENT_FORM_FIELD_QUERY,
} from '../../../app/graphql/jobFormQueries';
import { DynamicFormSchemaProvider } from '../../../components/forms/dynamic/dynamicFormSchema';

const REQUIRED = { validation: { rules: { required: true } } };

function mergeWithArrays(oldValues, newValues) {
  return mergeWith({}, oldValues, newValues, (_, b) =>
    isArray(b) ? b : undefined
  );
}

function overrideShipmentSchema(schema) {
  const newSchema = mergeWithArrays(schema, {
    packages: {
      packageSource: {
        autofill: {
          listenTo: ['accountNumber'],
          dependsOn: ['accountNumber'],
        },
      },
      packagingType: {
        autofill: {
          listenTo: ['accountNumber'],
          dependsOn: ['accountNumber'],
        },
      },
    },
    serviceInformation: {
      dangerousGoods: REQUIRED,
      exceptedQuantity: REQUIRED,
      unNumber: REQUIRED,
    },
    origin: {
      address: {
        country: {
          option: {
            dependsOn: [],
          },
        },
      },
    },
    destination: {
      address: {
        country: {
          option: {
            dependsOn: [],
          },
        },
      },
    },
  });
  return newSchema;
}

export default function NewShipmentFormSchemaProvider({ account, children }) {
  return (
    <DynamicFormSchemaProvider
      query={SHIPMENT_FORM_SCHEMA_QUERY}
      optionsQuery={SHIPMENT_FORM_GET_OPTIONS_QUERY}
      fieldValidationQuery={VALIDATE_SHIPMENT_FORM_FIELD_QUERY}
      autofillQuery={SHIPMENT_FORM_AUTOFILL_QUERY}
      variables={account && { accountNumber: account.number }}
      skip={!account}
      modifySchema={modifySchema => overrideShipmentSchema(modifySchema)}
      queryName="newShipmentAsyncFieldValidation"
      clearCache
    >
      {children}
    </DynamicFormSchemaProvider>
  );
}
